
export function log(message: string, ...args) {
  console.log(message, ...args)
}

export enum LogKinds {
  Flowsheet = 'Flowsheet'
}